import ChargebeeWidgetContainer from "../ChargebeeWidget";
import { ChargebeeWidgetForward } from "../ChargebeeWidget/ChargebeeWidget";

export default function OrganizationBillingAddress() {
  return (
    <ChargebeeWidgetContainer forward={ChargebeeWidgetForward.BillingAddress} />
  );
}
